import { Component, type EventEmitter, Prop, h, Event, Listen, State } from '@stencil/core';
import { GenericCardTitle } from '../../../../new-result-cards/generic-subcomponents/generic-card-title/generic-card-title';
import { GenericCardEventsLayer } from '../../../../new-result-cards/generic-subcomponents/generic-card-event-layer/generic-card-event-layer';
import type { SearchProduct } from '../../../../../../api/model/response/documents/public/Product';
import { ResultCardType } from '../../../../new-result-cards/public/product-card/helpers/helpers';
import type { SearchResultClickEvent } from '../../../SearchResultClickEvent';
import {Strategies} from '../../../../../strategies/Strategies';
import { GenericVideoCardThumbnail } from '../../../../new-result-cards/public/video-card/subcomponents/video-card-thumbnail/video-card-thumbnail';
import { GenericReadArticle } from '../../../../new-result-cards/public/video-card/subcomponents/video-card-read-article/video-card-read-article';
import {getFaqIdFromDoc} from '../../../../new-result-cards/public/video-card/helpers/helpers';
import type {Support} from '../../../../../../api/model/response/documents/public/Document';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

@Component({
  tag: 'dashboard-video-item',
  shadow: false,
  styleUrl: 'dashboard-company-tile.scss',
})
export class DashboardVideoItem {
    @Prop() readonly doc: Support;
    @Prop() readonly index: number;
    @Prop() readonly strategies: Strategies;
    @Prop() readonly section: string;
    @Prop() readonly country: string;
    @Prop() readonly language: string;
    @Prop() readonly labelProvider: labelProviderInterface;

    @State() accessibilityMode;
    @State() isDialogOpen = false;

    @Event({
      eventName: 'search:ResultCardClick',
      composed: true,
      cancelable: true,
      bubbles: true,
    })
      resultCardClickEventEmitter: EventEmitter<SearchResultClickEvent>;

    @Listen('uiaas:accessibility', { target: 'window' })
    handleAccessibility(ev) {
        this.accessibilityMode = ev.detail;
    }

    private toggleDialog = (isOpen: boolean) => {
        this.isDialogOpen = isOpen;
    };

    connectedCallback() {
        const htmlElement = document.querySelector('html');
        const isAccessibilityOn = htmlElement.classList.contains('se2-accessibility');
        this.accessibilityMode = isAccessibilityOn;
    }

    render() {
        const accessibilityModeClass = this.accessibilityMode ? '--accessibility' : '';

        return (
          <div class="video-item__container">
            <GenericCardEventsLayer
              clickEmitter={this.resultCardClickEventEmitter}
              doc={this.doc as unknown as SearchProduct}
              index={this.index}
              resutCardType={ResultCardType.Basic}
              section={this.section}
            >
              <div onClick={(e) => {
                  e.preventDefault();
                  this.toggleDialog(true);
              }}
              class="video-widget-thumbnail">
                <GenericVideoCardThumbnail url={this.doc?.url} imageUrl={this.doc?.thumbnailUrl} />
              </div>
              {this.isDialogOpen && <se-dialog
                color='alternative'
                page-scroll={false}
                closeIcon
                size='large'
                onClick={(e) => {
                    e.preventDefault();
                    this.toggleDialog(false);
                }}
                open={this.isDialogOpen}
              >
                <se-icon
                  class="video-frame_icon"
                  size="small"
                  color="alternative"
                >
                  action_delete_cross
                </se-icon>
                <iframe class='video-frame' frameborder="0" src={`https://www.youtube.com/embed${new URL(this.doc?.url)?.pathname}`} title="YouTube video player" referrerPolicy="strict-origin-when-cross-origin" allowfullScreen></iframe>
              </se-dialog>}
              <a href={this.doc.url} tabindex="0">
                <GenericCardTitle
                  url={this.doc.url}
                  text={this.doc.title}
                  strategies={this.strategies}
                />
                {this.doc._id.includes('SE-FAQ-') && <GenericReadArticle faqId={getFaqIdFromDoc(this.doc, this.country, this.language)} labelProvider={this.labelProvider}/>}
              </a>
            </GenericCardEventsLayer>
          </div>
        );
    }
}
